import React from "react";
import { useSelector } from "react-redux";
import { BackButton } from "@qgiv/core-donor";
import { selectIsCms, selectHTTP } from "../../../redux/slices/configSlice";
import { selectThemeSettings } from "../../../redux/slices/cmsSettingsSlice";
import { selectAllP2pSettings } from "../../../redux/slices/p2pSettingsSlice";
import { ThemeType } from "../../../redux/constants";

const ConnectedBackButton = (props) => {
    const isCms = useSelector(selectIsCms);
    const HTTP_HOST = useSelector(selectHTTP);
    const themeSettings = useSelector((state) =>
        selectThemeSettings(ThemeType.HEADER, state),
    );
    const {
        registrationStatus: { backLinkLabel = "Back to Fundraiser" },
    } = themeSettings;

    const p2pSettings = useSelector(selectAllP2pSettings);
    const { alias } = p2pSettings;

    const backButtonProps = {
        backLinkLabel,
        backLinkUrl: `${HTTP_HOST}/event/${alias}`,
        isCms,
        withRouter: false,
        centered: true,
        ...props,
    };

    return <BackButton {...backButtonProps} />;
};

export default ConnectedBackButton;
